var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlignIconInverse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4442_5290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.1 0H5.9C2.64152 0 0 2.64152 0 5.9V74.1C0 77.3585 2.64152 80 5.9 80H74.1C77.3585 80 80 77.3585 80 74.1V5.9C80 2.64152 77.3585 0 74.1 0Z",
    fill: "#202D63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.23 26.79H65",
    stroke: "white",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 26.79H28.43",
    stroke: "white",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.71 40.04H65",
    stroke: "white",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 40.04H48.91",
    stroke: "white",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.07 53.3H65",
    stroke: "white",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 53.3H32.26",
    stroke: "white",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.23 26.7001C36.23 24.5501 34.48 22.8 32.33 22.8C30.18 22.8 28.43 24.5501 28.43 26.7001C28.43 28.8501 30.18 30.6 32.33 30.6C34.48 30.6 36.23 28.8501 36.23 26.7001Z",
    stroke: "white",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.81 36.1399C50.66 36.1399 48.91 37.8899 48.91 40.0399C48.91 42.1899 50.66 43.9399 52.81 43.9399C54.96 43.9399 56.71 42.1899 56.71 40.0399C56.71 37.8899 54.96 36.1399 52.81 36.1399Z",
    stroke: "white",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.17 49.3899C34.02 49.3899 32.27 51.1399 32.27 53.2899C32.27 55.4399 34.02 57.1899 36.17 57.1899C38.32 57.1899 40.07 55.4399 40.07 53.2899C40.07 51.1399 38.32 49.3899 36.17 49.3899Z",
    stroke: "white",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4442_5290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignIconInverse);
export default __webpack_public_path__ + "static/media/Align-Icon-Inverse.39615d367dc40cf712e41d1d0be42673.svg";
export { ForwardRef as ReactComponent };